import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { Store } from "@ngrx/store";
import { GlobalState } from "src/app/common/providers/app-state-provider/types/global-state";

export const isLandlordGuard: CanActivateFn = () => {
  const store = inject(Store);

  const landlordAccess = store.selectSignal((state: GlobalState) =>{
    return state.appState.accountType === 'LandlordRep';
  });

  return landlordAccess();
};
